import React from 'react';
import { useFormState } from 'react-hook-form';
import { PrimaryButton } from '../../Button';
import { IFilterWidgetState } from '../types';
import { FilterType } from '../../../utils/apollo/graphqlSchema';

const FilterWidgetSubmit = () => {
  const { isSubmitting, isValid, isDirty, defaultValues } =
    useFormState<IFilterWidgetState>();

  const isBasicForm = defaultValues?.type === FilterType.Basic;

  const isGreyedOut = isBasicForm && (!isValid || !isDirty); // disabled but clickable
  const disabled = (isBasicForm && !isDirty && isValid) || isSubmitting; // not clickable

  return (
    <PrimaryButton
      type="submit"
      isGreyedOut={isGreyedOut}
      disabled={disabled}
      trackContext="filter"
      trackAction="confirm"
    >
      Confirm
    </PrimaryButton>
  );
};

export default FilterWidgetSubmit;
